<template>
  <b-modal
    v-model="isShow"
    size="md"
    :title="`Tiến trình tạo phiếu gán ${total > 0 ? ((done / total) * 100).toFixed(2).replace('.00', '') : '0'}%`"
    v-b-modal.modal-scrollable
    :hide-footer="true"
    hide-header-close
    no-close-on-backdrop
    :busy="isLoading"
  >
    <div>Đã lưu: {{ done.toLocaleString('vi-VN') }}/{{ total.toLocaleString('vi-VN') }}</div>
    <div>{{ message }}</div>
    <div class="text-danger">{{ error }}</div>
  </b-modal>
</template>

<script>
  import { showMess } from '@/config/utils'
  import { GetIdsByCustomerIds } from '@/services/customer-support/account'
  import { ExecSqlGetOnlyIds } from '@/services/customer-support/filter-services'
  import { AssignOrder } from '@/services/customer-support/store-staff'

  const pageSize = 200

  export default {
    name: 'PopupEdit',
    data() {
      return {
        isShow: false,
        query: '',
        total: 0,
        done: 0,
        isLoading: false,
        paramsAssign: {},
        message: '',
        error: '',
      }
    },

    methods: {
      show(query, paramsAssign) {
        this.isShow = true
        this.query = query
        this.paramsAssign = paramsAssign
        this.message = ''
        this.error = ''

        this.saveData()
      },

      async saveData() {
        try {
          this.isLoading = true
          let page = 1

          do {
            this.message = `Đang lấy thông tin filter service của page: ${page}`
            const resCustomerIds = await ExecSqlGetOnlyIds({
              page: page,
              limit: pageSize,
              req: this.query,
            })

            if (resCustomerIds.code !== 1000) {
              return showMess(
                this,
                'Thông báo',
                resCustomerIds.message,
                'danger',
                'b-toaster-top-right',
                5 * 60 * 60
              )
            }

            const customerIds =
              resCustomerIds.data?.content?.reduce((arr, item) => {
                arr.push(item.merchantIdMyNP)
                return arr
              }, []) || []

            this.total = resCustomerIds.data?.totalElements || 0

            if (customerIds.length === 0) {
              // return showMess(this, 'Thông báo', 'Không có dữ liệu', 'danger', 'b-toaster-top-right', 5 * 60 * 60)
              break
            }

            this.message = `Convert customerIds sang Maids của page: ${page}`
            const resConvertIds = await GetIdsByCustomerIds(customerIds)
            if (resConvertIds.code !== 1000) {
              return showMess(
                this,
                'Thông báo',
                resConvertIds.message,
                'danger',
                'b-toaster-top-right',
                5 * 60 * 60
              )
            }

            const maIds = Object.values(resConvertIds.data) // .filter(id => !this.deleteds.includes(id));

            if (maIds.length === 0) {
              // return showMess(this, 'Thông báo', 'Không có dữ liệu', 'danger', 'b-toaster-top-right', 5 * 60 * 60)
              break
            }

            this.message = `Đang lưu thông tin page: ${page}`
            await AssignOrder({
              ...this.paramsAssign,
              assignmentIds: maIds,
            })
            this.done += customerIds.length
            page++
          } while (this.done < this.total)

          this.isShow = false
          this.$emit('done')
        } catch (e) {
          showMess(this, 'Thông báo', e.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
          this.error = e.response?.data?.message ? e.response.data.message : e.message
        } finally {
          this.isLoading = false
        }
      },
    },
  }
</script>

<style scoped></style>
